import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';

import { getIntlLocale } from '../intl/intlSelectors';
import { FEATURES, isFeatureEnabled } from '../utils/featureFlag';
import { getTermsAndConditionsPath, getPrivacyPolicyPath, getFAQPath } from '../routing/flow';

import CashstarLink from './CashstarLink';
import footerLinksDefault from './footerLinksMessages';


export const CashstarLinksDefault = ({
    intl,
    selectedLocale
}) => {
    const storefrontDocs = !isFeatureEnabled(FEATURES.LEGACY_LEGAL_DOCS);
    return (
        <Fragment>
            <CashstarLink
                url={storefrontDocs ? getFAQPath() : '/about/faq/'}
                linkText={intl.formatMessage(footerLinksDefault.faq)}
                external
            />
            <CashstarLink
                url={`/self_service/register/?locale=${selectedLocale}`}
                linkText={intl.formatMessage(footerLinksDefault.support)}
                external
            />
            <CashstarLink
                url={storefrontDocs ? getTermsAndConditionsPath() : '/about/terms_and_conditions/'}
                linkText={intl.formatMessage(footerLinksDefault.terms)}
                external
            />
            <CashstarLink
                url={storefrontDocs ? getPrivacyPolicyPath() : '/about/privacy_policy/'}
                linkText={intl.formatMessage(footerLinksDefault.privacy)}
                external
            />
            <CashstarLink
                url={intl.formatMessage(footerLinksDefault.accessibilityLink)}
                linkText={intl.formatMessage(footerLinksDefault.accessibility)}
                external
            />
        </Fragment>
    );
};

CashstarLinksDefault.propTypes = {
    selectedLocale: PropTypes.string.isRequired,
    intl: intlShape.isRequired
};

export const mapStateToProps = state => ({
    selectedLocale: getIntlLocale(state)
});

export default connect(mapStateToProps)(injectIntl(CashstarLinksDefault));
